import {
  getSurveySampleByIdApi,
  updateSurveySampleByIdApi,
  updateSurveyDimensionByIdApi,
  getSurveySampleDimensionsByIdApi,
  moveSampleOnSectionApi,
} from '../api/survey.sample';
import { clearSurveyCacheApi } from '../api/surveys';
import types from '../types';
import { QUESTION_FILTER_TYPE } from '../constants/common';

export const getSurveySampleById = (id, jwt) => async (dispatch) => {
  try {
    dispatch({ type: types.reducerTypes.SURVEY_SAMPLE_DIMENSION_GET_PENDING });
    const responses = await Promise.all([
      getSurveySampleByIdApi(id, jwt),
      getSurveySampleDimensionsByIdApi(id, jwt),
    ]);
    dispatch({
      type: types.reducerTypes.SURVEY_SAMPLE_DIMENSION_GET_SUCCESS,
      payload: {
        sample: responses[0],
        dimensions: responses[1],
      },
    });
  } catch (e) {
    console.log(e);
    dispatch({ type: types.reducerTypes.SURVEY_SAMPLE_DIMENSION_GET_ERROR, payload: e });
  }
};

export const updateSurveySampleById = (
  id,
  sample,
  dimensions,
  surveyLocationFilter,
  jwt,
  surveyId
) => async (dispatch) => {
  try {
    dispatch({ type: types.reducerTypes.SURVEY_SAMPLE_DIMENSION_UPDATE_PENDING });
    if (
      sample.Data.filterType === QUESTION_FILTER_TYPE.LOCATION &&
      surveyLocationFilter &&
      surveyLocationFilter.id !== id
    ) {
      await updateSurveySampleByIdApi(
        surveyLocationFilter.id,
        {
          Id: surveyLocationFilter.id,
          Data: {
            filterType: QUESTION_FILTER_TYPE.NONE,
          },
        },
        jwt
      );
    }

    const promises = [updateSurveySampleByIdApi(id, sample, jwt)];
    dimensions.forEach((dimension) => {
      promises.push(updateSurveyDimensionByIdApi(dimension.Id, dimension, jwt));
    });
    await Promise.all(promises);

    await clearSurveyCacheApi(surveyId, jwt);

    dispatch({ type: types.reducerTypes.SURVEY_SAMPLE_DIMENSION_UPDATE_SUCCESS });
  } catch (e) {
    console.log(e);
    dispatch({ type: types.reducerTypes.SURVEY_SAMPLE_DIMENSION_UPDATE_ERROR, payload: e });
  }
};

export const autoSavingSurveySample = () => async (dispatch) => {
  dispatch({ type: types.reducerTypes.SURVEY_SAMPLE_DIMENSION_AUTO_SAVING });
};

export const autoSavedSurveySample = () => async (dispatch) => {
  dispatch({ type: types.reducerTypes.SURVEY_SAMPLE_DIMENSION_AUTO_SAVED });
};

export const setAutoSavedPending = () => async (dispatch) => {
  dispatch({ type: types.reducerTypes.SURVEY_AUTO_SAVING_PENDING });
};

export const moveSampleDimensionToSection = (id, sample, jwt, surveyId) => async (dispatch) => {
  try {
    dispatch({ type: types.reducerTypes.MOVE_SAMPLE_DIMENSION_TO_SECTION_PENDING });

    await updateSurveySampleByIdApi(id, sample, jwt);

    await clearSurveyCacheApi(surveyId, jwt);

    dispatch({ type: types.reducerTypes.MOVE_SAMPLE_DIMENSION_TO_SECTION_SUCCESS });
  } catch (e) {
    console.log(e);
    dispatch({ type: types.reducerTypes.MOVE_SAMPLE_DIMENSION_TO_SECTION_ERROR, payload: e });
  }
};

export const moveSampleOnSection = (id, place, surveyId, jwt) => async (dispatch) => {
  try {
    dispatch({ type: types.reducerTypes.MOVE_SAMPLE_ON_SECTION_PENDING });

    await moveSampleOnSectionApi(id, place, jwt);

    await clearSurveyCacheApi(surveyId, jwt);

    dispatch({ type: types.reducerTypes.MOVE_SAMPLE_ON_SECTION_SUCCESS });
  } catch (e) {
    console.log(e);
    dispatch({ type: types.reducerTypes.MOVE_SAMPLE_ON_SECTION_ERROR, payload: e });
  }
};
